import React from 'react'
import styled from 'styled-components'
import { colors, sizes, breakpoints } from '../css-variables'
import Accordion from './Accordion'

const ProductMenu = ({ items, className, menuTitle }) => {
    const itemsList = items
        .filter(item => !item?.hideFromMenu?.hideFromMenu)
        .map(item => (
            <div className="menu__item" key={item.title}>
                <a className="menu__link" href={item.uri}>
                    <span>{item.title}</span>
                </a>
            </div>
        ))

    return (
        itemsList.length > 0 && (
            <Accordion
                opentext={`${menuTitle} menu`}
                closetext={`${menuTitle} menu`}
                useAsMenu>
                <div className={className}>
                    {itemsList && (
                        <section className="menu__items">{itemsList}</section>
                    )}
                </div>
            </Accordion>
        )
    )
}

const StyledProductMenu = styled(ProductMenu)`
    margin-bottom: 48px;
    width: 80%;
    max-width: 500px;
    margin: 0 auto;

    @media screen and ${breakpoints.tabletS} {
        width: max-content;
    }

    .menu__link {
        color: ${colors.copyText};
        font-size: ${sizes.s16};
        line-height: ${sizes.s32};
        text-decoration: none;
        &:hover {
            color: ${colors.linkTextHover};
        }
    }
`

export default StyledProductMenu
